import React, { Fragment } from "react";

export const ReportTitleInfoInlineWhiteSpace = {
  whiteSpaceOnly: true,
};

const ReportInlineInfoSection = ({ rows, fontSizeOverride = null, titleInlineStyle = {} }) => {
  return (
    <div style={fontSizeOverride ? { fontSize: fontSizeOverride } : {}}>
      {rows.map((row) => {
        return (
          <Fragment>
            <div className={`report-inline-info-flex-container ${row.className ? row.className : ""}`}>
              {row.cols.map((col) => {
                return (
                  <div className="report-inline-info-property">
                    {col.whiteSpaceOnly ? (
                      <div className="no-value-space"></div>
                    ) : col.titleOnly ? (
                      <Fragment>
                        <label className="title" style={titleInlineStyle}>
                          {col.title}
                        </label>
                        <div className="no-value-space"></div>
                      </Fragment>
                    ) : (
                      <Fragment>
                        <label className="title" style={titleInlineStyle}>{`${col.title}:`}</label>
                        <div className="value">{col.value}</div>
                      </Fragment>
                    )}
                  </div>
                );
              })}
            </div>
            <span className="quarter-spacer"></span>
          </Fragment>
        );
      })}
    </div>
  );
};

export default ReportInlineInfoSection;



// WEBPACK FOOTER //
// ./src/libraries/ReportGenerator/ReportInlineInfoSection.jsx